import { render, staticRenderFns } from "./GeneralWindow.vue?vue&type=template&id=5de34052&scoped=true&"
import script from "./GeneralWindow.vue?vue&type=script&lang=js&"
export * from "./GeneralWindow.vue?vue&type=script&lang=js&"
import style0 from "./GeneralWindow.vue?vue&type=style&index=0&id=5de34052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de34052",
  null
  
)

export default component.exports